import * as THREE from "three";

function boundsCorners(bounds: THREE.Box3): THREE.Vector3[] {
  const { min, max } = bounds;
  return [
    new THREE.Vector3(min.x, min.y, min.z),
    new THREE.Vector3(min.x, min.y, max.z),
    new THREE.Vector3(min.x, max.y, min.z),
    new THREE.Vector3(min.x, max.y, max.z),
    new THREE.Vector3(max.x, min.y, min.z),
    new THREE.Vector3(max.x, min.y, max.z),
    new THREE.Vector3(max.x, max.y, min.z),
    new THREE.Vector3(max.x, max.y, max.z),
  ];
}

export function perspectiveFitDistance(
  bounds: THREE.Box3,
  target: THREE.Vector3,
  direction: THREE.Vector3,
  verticalFovDeg: number,
  aspect: number,
  padding = 1.12,
): number {
  const safeAspect = Math.max(0.1, aspect);
  const verticalHalfFov = THREE.MathUtils.degToRad(verticalFovDeg) / 2;
  const horizontalHalfFov = Math.atan(Math.tan(verticalHalfFov) * safeAspect);
  const cameraFrame = new THREE.Object3D();
  cameraFrame.position.copy(direction.clone().normalize());
  cameraFrame.lookAt(0, 0, 0);
  const inverseCameraRotation = cameraFrame.quaternion.clone().invert();

  const distance = boundsCorners(bounds).reduce((requiredDistance, corner) => {
    const cameraLocal = corner.clone().sub(target).applyQuaternion(inverseCameraRotation);
    const horizontalDistance = cameraLocal.z + Math.abs(cameraLocal.x) / Math.tan(horizontalHalfFov);
    const verticalDistance = cameraLocal.z + Math.abs(cameraLocal.y) / Math.tan(verticalHalfFov);
    return Math.max(requiredDistance, horizontalDistance, verticalDistance);
  }, 0);

  return Math.max(0.1, distance * Math.max(1, padding));
}
